import { render } from "./SiteInformatif.vue?vue&type=template&id=3adc4602&scoped=true"
import script from "./SiteInformatif.vue?vue&type=script&lang=js"
export * from "./SiteInformatif.vue?vue&type=script&lang=js"

import "./SiteInformatif.vue?vue&type=style&index=0&id=3adc4602&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adc4602"]])

export default __exports__